import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLolDrakeCloud = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.77102 14.4989C3.91676 14.5146 4.01565 14.3532 3.93498 14.2309C3.70856 13.8874 3.36763 13.2107 3.5498 12.4534C3.81526 11.3629 3.94539 10.7019 7.14909 8.5574C10.3528 6.41032 8.90059 3.14156 4.24208 0.5C4.24208 0.5 3.6487 0.632728 3.91155 1.09337C4.17701 1.55662 8.30461 3.96655 2.16006 10.5067C-0.208234 12.9661 2.66755 14.3844 3.77102 14.4989Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.31694 11.7091C5.17641 11.8236 4.98122 11.6622 5.0671 11.5009C5.3794 10.9075 6.18619 9.91592 8.27341 8.6563C10.8941 7.07397 10.5532 4.2164 10.2175 2.87871C10.1732 2.70694 10.3971 2.59763 10.509 2.73296C11.4745 3.91971 13.3301 6.71222 11.8154 9.21845C11.6072 9.56198 11.2455 9.78319 10.8447 9.81963C9.68397 9.92633 7.01119 10.3193 5.31694 11.7091Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.14133 11.2042C7.18818 11.1807 7.24543 11.1729 7.29488 11.1885C7.71649 11.3109 9.66838 11.7663 10.5532 11.1651C11.5396 10.4937 13.1636 9.2835 13.6919 7.82869C14.2046 6.42073 13.9105 12.9739 11.8207 14.4391C11.7192 14.5094 11.576 14.4729 11.5214 14.3636C11.2611 13.8405 10.3867 12.5028 8.30726 12.7162C6.88889 12.862 6.11073 12.9869 5.69693 13.0702C5.52256 13.1066 5.38983 12.9166 5.48092 12.7631C5.74117 12.3389 6.25648 11.67 7.14133 11.2042Z",
			fill: "currentColor"
		})
	]
});
export default SvgLolDrakeCloud;
